import cargoAPI from '@/services/api/cargo'
import _ from 'lodash'
import cookies from 'vue-cookies'

const state = {
	list: null,
	count: null,
	loadParams: {
		keyword: '',
		qrBarcode: '',
		groupsId: [],
		offset: 0,
		length: 50,
		order: ['CREATE_DATETIME'],
		orderDirection: ['DESC'],
		startDatetime: null,
		endDatetime: null,
		status: JSON.parse(cookies.get('filter_cargo_status')) || [],
		categoriesId:
			JSON.parse(cookies.get('filter_cargo_categoriesId')) || [],
		brandsId: JSON.parse(cookies.get('filter_cargo_brandsId')) || [],
		registerMethods:
			JSON.parse(cookies.get('filter_cargo_registerMethods')) || [],
		shipStatus: JSON.parse(cookies.get('filter_cargo_shipStatus')) || [],
	},
	filter: null,
	filterCookieName: {
		status: 'filter_cargo_status',
		categoriesId: 'filter_cargo_categoriesId',
		brandsId: 'filter_cargo_brandsId',
		registerMethods: 'filter_cargo_registerMethods',
		shipStatus: 'filter_cargo_shipStatus',
	},
	isFold: true,
}

const getters = {
	selectedStatus: state =>
		state.loadParams.status.length != 1
			? 'ALL'
			: state.loadParams.status[0],
	list: state => state.list,
	count: state => state.count,
	keyword: state => state.loadParams.keyword,
	qrBarcode: state => state.loadParams.qrBarcode,
	isEmptyList: state => state.count === 0,
	isIncludeCompleteSelectItem: state =>
		state.selectItem.map(i => i.status).some(i => i === 'COMPLETE'),
	isAllReadySelectItem: state =>
		state.selectItem.map(i => i.isReady).every(i => i),
	filteredCount: state =>
		state.loadParams.status.length +
		state.loadParams.categoriesId.length +
		state.loadParams.brandsId.length +
		state.loadParams.registerMethods.length +
		state.loadParams.shipStatus.length,
	filteredList: state => {
		return {
			status: state.loadParams.status,
			categoriesId: state.loadParams.categoriesId,
			brandsId: state.loadParams.brandsId,
			registerMethods: state.loadParams.registerMethods,
			shipStatus: state.loadParams.shipStatus,
		}
	},
	order: state => state.loadParams.order[0],
	orderDirection: state => state.loadParams.orderDirection[0],
	dateText: state => {
		if (state.loadParams.startDatetime)
			return `${state.loadParams.startDatetime} ~ ${state.loadParams.endDatetime}`
		return null
	},
	isFold: state => state.isFold,
}

const mutations = {
	setCargoList: (state, cargoList) => {
		state.list = [...state.list, ...cargoList.list]
		state.count = cargoList.count
		state.loadParams.offset = state.list.length
	},
	setLoadParams: (state, loadParams) => {
		if (loadParams != null)
			Object.keys(loadParams).forEach(key => {
				state.loadParams[key] = loadParams[key]
			})
	},
	setFilter: (state, data) => {
		state.filter = data
	},
	initOffset: state => {
		state.loadParams.offset = 0
		state.list = []
	},
	setFold: (state, fold) => {
		state.isFold = fold
	},
	initFilterCookies: (state, needReset) => {
		if (needReset)
			Object.values(state.filterCookieName).forEach(key => {
				cookies.set(key, JSON.stringify([]))
			})
		state.loadParams = {
			keyword: '',
			qrBarcode: '',
			groupsId: [],
			offset: 0,
			length: 50,
			order: ['CREATE_DATETIME'],
			orderDirection: ['DESC'],
			startDatetime: null,
			endDatetime: null,
			status: JSON.parse(cookies.get('filter_cargo_status')) || [],
			categoriesId:
				JSON.parse(cookies.get('filter_cargo_categoriesId')) || [],
			brandsId: JSON.parse(cookies.get('filter_cargo_brandsId')) || [],
			registerMethods:
				JSON.parse(cookies.get('filter_cargo_registerMethods')) || [],
			shipStatus:
				JSON.parse(cookies.get('filter_cargo_shipStatus')) || [],
		}
	},
}

const actions = {
	getCargoList: async ({ commit, rootGetters, state }, isMore = false) => {
		if (!isMore) commit('initOffset')
		const response = await cargoAPI.getCargoList(
			rootGetters.instituteId,
			state.loadParams
		)
		commit('setCargoList', response.data)
	},
	divideCargoItem: async ({ dispatch, rootGetters }, body) => {
		await cargoAPI.divideCargoItem(rootGetters.instituteId, body)
		dispatch('getCargoList')
	},
	deleteCargoItem: async (
		{ commit, dispatch, rootGetters, getters },
		ids
	) => {
		await cargoAPI.deleteCargoItem(rootGetters.instituteId, {
			ids: ids ? ids : getters.selectItemId,
		})
		if (!ids) {
			commit('setSelectItem', [])
		}
		dispatch('getCargoList')
	},
	setLoadParams: async ({ commit, dispatch }, loadParams) => {
		commit('setLoadParams', loadParams)
		return dispatch('getCargoList')
	},
	getFilter: async ({ commit, rootGetters }) => {
		const response = await cargoAPI.getFilter(rootGetters.instituteId)
		commit('setFilter', response.data)
	},
	getItemCount: async ({ commit, rootGetters }, filterPararms) => {
		const response = await cargoAPI.getCargoList(
			rootGetters.instituteId,
			filterPararms
		)
		return response.data.count
	},
	exportExcel: async ({ state, rootGetters }, type) => {
		const response = await cargoAPI.exportExcel(
			rootGetters.instituteId,
			type == 'ALL' ? null : state.loadParams
		)
		return response
	},
}
export default { namespaced: true, state, getters, mutations, actions }
